import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {ICall} from "./interface/call.interface";
import {ApiService} from "../api/api.service";
import {AppMessageService} from "../app-message/app-message.service";
import {TranslateService} from "@ngx-translate/core";
import {IPagination} from "../api/interface/pagination.interface";
import {environment} from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class CallService {
  public calls: ICall[] = [];
  private readonly callsSubject = new BehaviorSubject<ICall[]>(this.calls);
  calls$ = this.callsSubject.asObservable();
  callHeaderFunctionWithData$ = new Subject<any>();

  constructor(private readonly apiService: ApiService, private readonly messageService: AppMessageService, private readonly translateService: TranslateService) {
  }

  getFilter(event: any, filter: any): Observable<IPagination> {
    return this.apiService.getFilter<IPagination>(`calls/call-filter-list`, {event: event, filter: filter})
  }

  triggerCall(call: ICall) {
    this.apiService.post<ICall>('calls/trigger-create', call).subscribe(res => {
      if (!this.calls.find(call => call.ucid == res.ucid)) {
        this.calls.push(res);
        this.callsSubject.next([...this.calls]);
      }
    });
  }

  getOpenCallCard() {
    this.apiService.get<ICall[]>('calls/get-open-call-card').subscribe(res => {
      this.calls = res;
      this.callsSubject.next([...this.calls]);
    });
  }

  removeCall(ucid: string) {
    this.calls = this.calls.filter(call => call.ucid !== ucid);
    this.callsSubject.next([...this.calls]);
  }

  callAction(callId: any, phone: any, action: string, localResponse: any) {
    return this.apiService.post('calls/call-action', {
      callId: callId,
      action: action,
      phone: phone,
      station: localStorage.getItem('station'),
      localResponse: localResponse
    });
  }

  callLocalApi(action: any, phone: any, callId: any, station: any) {
    const url = environment.callActionApiUrl + action;
    const data = {
      station: station,
      phone: environment.callActionPrefix + phone,
      callId: callId,
    };

    const headers = {
      Authorization:
        'Basic ' +
        btoa(`${environment.callActionApiUser}:${environment.callActionApiPassword}`),
      'Content-Type': 'application/json',
    };

    return this.apiService.postCustom(url, data, {showLoader: true, message: 'Loading...'}, headers);
  }


  saveStation(station: string) {
    if (station != undefined) {
      localStorage.setItem('station', station);
      this.messageService.successToast(this.translateService.instant('common.success'), this.translateService.instant('common.saveSuccessToastMessage'));
    }
  }

  linkCaseToCallCard(callCardId: number, caseId: number) {
    return this.apiService.post('calls/link-case-to-call-card', { callCardId, caseId });
  }
}
